import { useEffect } from "react";
import { useAtom } from "jotai";
import { isCommandPaletteOpenAtom } from "@/store/ui-atoms";

export const useCommandPalette = () => {
  const [isDialogOpen, setIsDialogOpen] = useAtom(isCommandPaletteOpenAtom);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === "k") {
        e.preventDefault();
        setIsDialogOpen(true);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [setIsDialogOpen]);

  const handleDialogChange = (open: boolean) => {
    setIsDialogOpen(open);

    if (!open) {
      setTimeout(() => {
        const metaKeyUp = new KeyboardEvent("keyup", {
          key: "Meta",
          code: "MetaLeft",
          bubbles: true,
        });
        const ctrlKeyUp = new KeyboardEvent("keyup", {
          key: "Control",
          code: "ControlLeft",
          bubbles: true,
        });

        document.dispatchEvent(metaKeyUp);
        document.dispatchEvent(ctrlKeyUp);
      }, 100);
    }
  };

  return { isDialogOpen, setIsDialogOpen, handleDialogChange };
};
